module.exports = __webpack_public_path__ + "static/fonts/BMYEONSUNG_otf.otf?6f67016d";